import { Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Products from './pages/Products';
import ProjectDetail from './pages/ProjectDetail';
import DCIC from './pages/DCIC';
import JoinUs from './pages/JoinUs';
import RoleDetail from './pages/RoleDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import RefundPolicy from './pages/RefundPolicy';
import PrivacyPolicy from './pages/DataNotice';
import TermsAndConditions from './pages/TermsAndConditions';
import Pricing from './pages/Pricing';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import LandingPage from './pages/LandingPage';
import ModuleDetail from './pages/ModuleDetail';
import NotFound from './pages/NotFound';
import { landingPages } from './data/landing';
import { useEffect, Fragment } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';

// Always start a new page from the top
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="app-container">
      <ScrollToTop />
      <Navbar />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:slug" element={<ProjectDetail />} />
          <Route path="/dcic" element={<DCIC />} />

          <Route path="/join" element={<JoinUs />} />
          <Route path="/join/:slug" element={<RoleDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/pricing" element={<Pricing />} />
          {landingPages.map((p) => (
            <Fragment key={p.slug}>
              <Route path={`/${p.slug}`} element={<LandingPage slug={p.slug} />} />
              <Route path={`/${p.slug}/:moduleSlug`} element={<ModuleDetail landingSlug={p.slug} />} />
            </Fragment>
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
